module.exports = __webpack_public_path__ + "static/img/CW.a266452b.svg";